import React, { useEffect, useState } from 'react';
import { academicProgramsService } from '../../../../services';

const ProgramCard = ({ program }) => (
    <div className="border rounded p-3 bg-light mb-2">
        <div>
            <strong>{program?.programName || <span className="text-muted">—</span>}</strong>
            {program?.programId
                ? <span className="text-muted ml-2">(ID: {program.programId})</span>
                : null}
        </div>
        <div className="text-muted small mt-1">
            {program?.cipCode
                ? <span className="mr-3">CIP: {program.cipCode}{program.cipTitle ? ` — ${program.cipTitle}` : ''}</span>
                : null}
            {program?.degreeLevel ? <span className="mr-3">Level: {program.degreeLevel}</span> : null}
            {program?.status ? <span>Status: {program.status}</span> : null}
        </div>
        <div className="text-muted small">
            {program?.deliveryMode ? <span className="mr-3">Delivery: {program.deliveryMode}</span> : null}
            {(program?.creditRequirementMinimum || program?.creditRequirementMaximum)
                ? <span>Credits: {program.creditRequirementMinimum ?? '—'}–{program.creditRequirementMaximum ?? '—'}</span>
                : null}
        </div>
    </div>
);

export const ConsolidateRequestView = ({ requestDetails }) => {
    const [sourcePrograms, setSourcePrograms] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!requestDetails.requestID) return;
        setSourcePrograms(null);
        setError(false);
        const res = academicProgramsService.getConsolidatedProgramRequest(requestDetails.requestID);
        Promise.resolve(res)
            .then(data => setSourcePrograms(data))
            .catch(() => setError(true));
    }, [requestDetails.requestID]);

    const proposedProgram = {
        programName: requestDetails.programName,
        cipCode: requestDetails.cipCode,
        cipTitle: requestDetails.cipTitle,
        degreeLevel: requestDetails.degreeLevel,
        deliveryMode: requestDetails.deliveryMode,
        creditRequirementMinimum: requestDetails.creditRequirementMinimum,
        creditRequirementMaximum: requestDetails.creditRequirementMaximum,
    };

    return (
        <div className="request-type-details">
            <h5 className="mb-1">Consolidation Request Details</h5>
            <hr className="mt-2 mb-3" />

            <div className="text-muted small font-weight-bold mb-2">
                PROGRAMS BEING CONSOLIDATED{sourcePrograms ? ` (${sourcePrograms.length})` : ''}
            </div>

            {sourcePrograms === null && !error && (
                <p className="text-muted font-italic small">Loading source programs…</p>
            )}
            {error && (
                <div className="alert alert-warning">Could not load source program details.</div>
            )}
            {sourcePrograms && sourcePrograms.map(p => (
                <ProgramCard key={p.programId} program={p} />
            ))}
            {sourcePrograms && sourcePrograms.length === 0 && (
                <p className="text-muted small font-italic">No source programs found.</p>
            )}

            <div className="text-muted small font-weight-bold mt-3 mb-2">NEW CONSOLIDATED PROGRAM</div>
            <ProgramCard program={proposedProgram} />

            {requestDetails.additionalComments && (
                <div className="mt-3">
                    <div className="text-muted small font-weight-bold">Comments</div>
                    <div>{requestDetails.additionalComments}</div>
                </div>
            )}
        </div>
    );
};
